<template >
  <!-- https://vuetifyjs.com/en/components/selects/ -->
  <v-select
    :items="formDetail.enum"
    :label="formDetail.title"
    v-model="pdValue"
    :name="index"
    :rules="[rulesForm.required]"
  >
  <template v-slot:append-inner>
      <v-tooltip location="bottom" v-if="formDetail.description">
        <template v-slot:activator="{ props }">
          <v-icon v-bind="props" icon="mdi-help-circle-outline"></v-icon>
        </template>
        {{ formDetail.description }}
      </v-tooltip>
    </template>
  </v-select>
</template>
 
<script setup>
const props = defineProps({
  formDetail: {
    type: Object,
    required: true,
  },
  model: {
    type: Object,
    required: true,
  },
  index: {
    type: String,
    required: false,
  },
});
const { $form} = useNuxtApp()
const rulesForm = $form.getRules(props.formDetail, props.index);

let pdValue = ref(props.model[props.index] ? props.model[props.index] : "");
</script>
<style scoped>
/* background color of select options, otherwise it will be transperant */
.v-overlay__content {
  background-color: white !important;
}
</style>